module.exports = __webpack_public_path__ + "static/media/call.01746ded.svg";